import { useTranslation } from 'react-i18next';

/**
 * The profile page's KoobPageHeader props, the same in both apps: DMC renders
 * the header above its content, TO passes it to KoobLayout. Notification
 * preferences live in each app's settings modal.
 */
export default function useProfileHeader() {
  const { t } = useTranslation('pages');

  return { title: t('profile') };
}
